import { EntityRepository } from 'root/lsCloud/EntityRepository/EntityRepository';

export class ConfigRepository extends EntityRepository {
  protected entitySet: Record<string, any> = {};

  constructor() {
    super('Config');
  }

  clearCache(): void {
    super.clearCache();
    this.entitySet = {};
  }

  access(name: string): JQuery.Deferred<any> {
    const deferred = $.Deferred();
    if (this.entitySet[name]) {
      deferred.resolve(this.entitySet[name]);
    } else {
      this.getAll()
        .then((entities) => {
          entities.forEach((entity) => {
            this.entitySet[entity.name] = entity.value;
          });
          deferred.resolve(this.entitySet[name]);
        })
        .catch(() => deferred.reject(this.entitySet[name]));
    }
    return deferred;
  }

  getCurrent(name: string): any | undefined {
    return this.entitySet[name];
  }

  set(name: string, value: any): void {
    this.entitySet[name] = value;
  }
}
